export default {
    computed: {
        sizeClasses() {
            let result = {};

            if (this.xsSize !== undefined) {
                result['col-' + this.xsSize] = true
            }

            if (this.smSize !== undefined) {
                result['col-sm-' + this.smSize] = true
            }

            if (this.mdSize !== undefined) {
                result['col-md-' + this.mdSize] = true
            }

            if (this.lgSize !== undefined) {
                result['col-lg-' + this.lgSize] = true
            }

            if (this.xlSize !== undefined) {
                result['col-xl-' + this.xlSize] = true
            }

            return result
        },
    },
    props: {
        xsSize: {
            type: String,
            default: "12",
        },
        smSize: {
            type: String,
            default: undefined,
        },
        mdSize: {
            type: String,
            default: undefined,
        },
        lgSize: {
            type: String,
            default: undefined,
        },
        xlSize: {
            type: String,
            default: undefined,
        },
    },
}